export const PHONE_CALL = 'phone-call';
export const VIDEO_CALL = 'video-call';
export const PERSONAL_AT_ORGANISATION = 'personal-at-organisation';
export const PERSONAL_NOT_AT_ORGANISATION = 'personal-not-at-organisation';